import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import { connect } from 'react-redux';
import { Field, change, reduxForm, formValueSelector } from 'redux-form';
import { getUserAbsence } from 'actions/user';
import User from "_class/User";
import DatePickerFromTo from '../Partials/DatePickerFromTo';
import { Expandable, Spinner } from 'UI';
import { Button, Radio, Icon, translate, getActiveLanguage } from '@haldor/ui';
import './_ReportAbsence.scss';

var ReportAbsenceForm = /*#__PURE__*/function (_Component) {
  _inherits(ReportAbsenceForm, _Component);

  var _super = _createSuper(ReportAbsenceForm);

  function ReportAbsenceForm(props) {
    var _this;

    _classCallCheck(this, ReportAbsenceForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.user != null) {
        _this.setState({
          loading: true
        });

        var start = Moment().subtract(1, 'weeks').second(0).format('YYYY-MM-DD');
        var end = Moment().add(3, 'weeks').second(0).format('YYYY-MM-DD');

        _this.props.getUserAbsence(_this.props.user.userId, start, end).then(function () {
          _this.setState({
            loading: false
          });

          _this.validateTime();
        });
      }

      if (_this.props.absence != null) {
        _this.selectAbsence(_this.props.absence);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateTime", function () {
      if (Moment(_this.state.timeStart).format('HH:mm:ss') === Moment(_this.state.timeEnd).format('HH:mm:ss')) {
        _this.setState({
          showError: false,
          timeValid: false
        });

        return true;
      }

      if (_this.state.timeEnd > _this.state.timeStart) {
        if (_this.state.timeValid == true) {
          // No need to update state to its current value
          return true;
        }

        _this.setState({
          timeValid: true
        });
      } else {
        if (_this.state.timeValid == false) {
          // No need to update state to its current value
          _this.setState({
            showError: true
          });

          return true;
        }

        _this.setState({
          timeValid: false,
          showError: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validatePeriod", function (value) {
      if (value == null || value == '') {
        return _this.props.translate('Required');
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "onTimeChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(time) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.props.entireDay == 'yes')) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _this.setState({
                  timeStart: time.start.set({
                    'minute': 0,
                    'hour': 0,
                    'second': 0
                  }).format(),
                  timeEnd: time.end.set({
                    'minute': 59,
                    'hour': 23,
                    'second': 0
                  }).format()
                });

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.next = 7;
                return _this.setState({
                  timeStart: time.start.second(0).format(),
                  timeEnd: time.start.set({
                    'minute': time.end.minute(),
                    'hour': time.end.hour(),
                    'second': 0
                  }).format()
                });

              case 7:
                _this.validateTime();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onModalClose) {
        _this.props.onModalClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDelete", function (event) {
      event.preventDefault();

      _this.props.onDelete(_this.state.id);
    });

    _defineProperty(_assertThisInitialized(_this), "onEntireDay", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var start, end;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              start = Moment(_this.state.timeStart);
              end = Moment(_this.state.timeEnd);
              start = start.set({
                'minute': 0,
                'hour': 0,
                'second': 0
              });
              end = end.set({
                'minute': 59,
                'hour': 23,
                'second': 0
              });
              _context2.next = 6;
              return _this.setState({
                timeStart: start.format(),
                timeEnd: end.format()
              });

            case 6:
              _this.validateTime();

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onPartOfDay", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.setState({
                timeStart: Moment().format(),
                timeEnd: Moment().format()
              });

            case 2:
              _this.validateTime();

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      var user = new User(_this.props.currentUser);
      return new Promise(function (resolve, reject) {
        values.startTime = Moment.utc(_this.state.timeStart).format();
        values.endTime = Moment.utc(_this.state.timeEnd).format();
        values.user = _this.props.user;
        values.type = _this.state.type;
        values.period = _this.props.entireDay == 'yes';

        if (_this.state.id != null) {
          values.id = _this.state.id;

          if (values.validAbsence == 'yes' && values.type.indexOf('INVALID') == 0) {
            values.type = values.type.replace('INVALID', 'VALID');
          }

          if (values.validAbsence == 'no' && values.type.indexOf('VALID') == 0) {
            values.type = values.type.replace('VALID', 'INVALID');
          }
        } else {
          values.type = values.validAbsence == 'yes' ? 'VALID_ABSENCE' : 'INVALID_ABSENCE';

          if (user.isStudent()) {
            values.type = 'VALID_ABSENCE';
          }
        }

        if (_this.props.onSubmit) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);

            _this.setState({
              submitResult: _this.props.submitResult
            });

            if (_this.props.submitResult != 'error') {
              var absenceObject = _this.props.userAbsence.find(function (absence) {
                return values.id == absence.id;
              });

              if (absenceObject != null) {
                absenceObject.startTime = _this.state.timeStart;
                absenceObject.endTime = _this.state.timeEnd;
                absenceObject.type = values.type;
              }

              if (_this.props.onModalClose) {
                _this.props.onModalClose();
              }
            }
          })["catch"](function (error) {
            _this.setState({
              submitResult: 'error'
            });

            reject(0);
          });
        } else {
          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectAbsence", function (absence) {
      if (_this.state.id == absence.id) {
        _this.props.dispatch(change(FORM_NAME, 'entireDay', ''));

        _this.props.dispatch(change(FORM_NAME, 'validAbsence', ''));

        _this.setState({
          id: null,
          origin: null,
          timeStart: Moment().format(),
          timeEnd: Moment().format(),
          type: null
        }, function () {
          _this.validateTime();
        });

        return true;
      }

      if (absence.period) {
        _this.props.dispatch(change(FORM_NAME, 'entireDay', 'yes'));
      } else {
        _this.props.dispatch(change(FORM_NAME, 'entireDay', 'no'));
      }

      _this.props.dispatch(change(FORM_NAME, 'validAbsence', absence.type.indexOf('VALID') == 0 ? 'yes' : 'no'));

      var user = new User(_this.props.currentUser);
      var isStudent = user.isStudent();

      if (isStudent && user.isAuthoritative) {
        if (absence.reportedBy.userId == _this.props.currentUser.id) {
          var start = Moment.utc(absence.startTime).local();
          var end = Moment.utc(absence.endTime).local();

          _this.setState({
            id: absence.id,
            origin: absence.origin,
            timeStart: start.format(),
            timeEnd: end.format(),
            type: absence.type
          }, function () {
            _this.validateTime();
          });
        }
      } else {
        var _start = Moment.utc(absence.startTime).local();

        var _end = Moment.utc(absence.endTime).local();

        _this.setState({
          id: absence.id,
          origin: absence.origin,
          timeStart: _start.format(),
          timeEnd: _end.format(),
          type: absence.type
        }, function () {
          _this.validateTime();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickAbsence", function (absence) {
      _this.selectAbsence(absence);
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      id: null,
      origin: null,
      type: null,
      loading: true,
      timeValid: false,
      showError: false,
      timeStart: Moment().format(),
      timeEnd: Moment().format(),
      submitResult: ""
    };
    return _this;
  }

  _createClass(ReportAbsenceForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          translate = _this$props.translate,
          valid = _this$props.valid,
          userAbsence = _this$props.userAbsence;
      var title = translate('registered-absence');
      var disabled = this.state.origin == 'ATTENDANCE';

      if (userAbsence != null && userAbsence.length > 0) {
        title = title + ' (' + userAbsence.length + ')';
      }

      var user = new User(this.props.currentUser);
      var isStudent = user.isStudent();
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container report-absence"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%'
        },
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          position: 'absolute'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, this.state.submitResult == 'error' ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginBottom: '1.8em',
          color: 'red',
          fontWeight: '500'
        }
      }, !isStudent ? this.props.translate('something-went-wrong-create-absence') : this.props.translate('something-went-wrong-create-absence-student')) : null, this.props.absence == null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '2.4em'
        }
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: title,
        open: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "absence-date-range"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Calendar",
        bw: true
      }), Moment().subtract(1, 'weeks').format('D MMMM'), " - ", Moment().add(3, 'weeks').format('D MMMM')), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        small: true
      }) : userAbsence != null && userAbsence.length > 0 ? userAbsence.map(function (absence) {
        var styles = {
          borderRadius: '4px',
          padding: '1rem',
          margin: '0.55rem 0',
          marginRight: '1.25rem',
          display: 'inline-block',
          cursor: 'pointer',
          border: '1px solid transparent',
          backgroundColor: 'white'
        };

        if (absence.id == _this2.state.id) {
          styles.border = '1px solid var(--color--blue)';
        }

        return /*#__PURE__*/React.createElement("div", {
          key: absence.id + absence.reported,
          style: styles,
          onClick: function onClick(e) {
            return _this2.clickAbsence(absence);
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            fontSize: 11,
            fontWeight: '500'
          }
        }, absence.origin == 'ATTENDANCE' ? _this2.props.translate('Reported lesson') : _this2.props.translate('Reported absence')), _this2.props.translate('start') + ': ' + Moment.utc(absence.startTime).local().format('Do MMMM YYYY - HH:mm'), /*#__PURE__*/React.createElement("br", null), _this2.props.translate('end') + ': ' + Moment.utc(absence.endTime).local().format('Do MMMM YYYY - HH:mm'), /*#__PURE__*/React.createElement("br", null));
      }) : /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center'
        }
      }, translate('no-absence-reported-error')))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, !isStudent ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, translate('type')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
        component: Radio,
        name: "validAbsence",
        optionValue: "yes",
        label: translate('VALID_ABSENCE'),
        validate: this.validatePeriod,
        disabled: disabled
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.35rem'
        }
      }, /*#__PURE__*/React.createElement(Field, {
        component: Radio,
        name: "validAbsence",
        optionValue: "no",
        label: translate('INVALID_ABSENCE'),
        validate: this.validatePeriod,
        disabled: disabled
      }))) : null, disabled && !isStudent && this.props.user != null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row edit-notice"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert",
        bw: true
      }), /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: translate('Editing of absences for reported lessons is done in {{link}}', "<a href=\"/user/".concat(this.props.user.userId, "/progress#attendance\">\n\t\t\t\t\t\t\t\t\t\t").concat(translate('student card'), "\n\t\t\t\t\t\t\t\t\t</a>"))
        }
      })) : null, this.state.origin == null || this.state.origin != "ATTENDANCE" ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('Period')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
        component: Radio,
        name: "entireDay",
        optionValue: "yes",
        label: translate('entire-day'),
        validate: this.validatePeriod,
        onChange: this.onEntireDay
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.35rem'
        }
      }, /*#__PURE__*/React.createElement(Field, {
        component: Radio,
        name: "entireDay",
        optionValue: "no",
        label: translate('part-of-day'),
        validate: this.validatePeriod,
        onChange: this.onPartOfDay
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
        timePicker: this.props.entireDay == 'no',
        onChange: this.onTimeChange,
        type: "plan" // To have values.timeStart and values.timeEnd
        ,
        values: this.state,
        hideEndDate: this.props.entireDay == 'no'
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), !this.state.timeValid && this.state.showError ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          color: 'red',
          marginTop: '1rem',
          fontWeight: 'bold'
        }
      }, translate('endTime-appears-before-startTime')) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid || !this.state.timeValid || disabled
      }, this.state.id != null ? translate('save') : translate('report-submit')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, this.state.id != null ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.onDelete,
        disabled: submitting || disabled,
        type: "secondary"
      }, translate('Delete')) : null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, translate('Cancel'))))));
    }
  }]);

  return ReportAbsenceForm;
}(Component);

var FORM_NAME = 'ReportAbsence';
var getFormValue = formValueSelector(FORM_NAME);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    userAbsence: state.user.absence,
    currentUser: state.user.currentUser,
    submitResult: state.Absence.submitResult,
    languages: state.Languages.languages,
    entireDay: getFormValue(state, 'entireDay')
  };
}

export default connect(mapStateToProps, {
  getUserAbsence: getUserAbsence
})(reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true
})(ReportAbsenceForm));